import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import SearchResultEntity from "../../../../domain/entities/SearchResultEntity";
import QrBatchEntity from "../../../../domain/entities/QrBatchEntity";
import QrBatchDto from "../../../dto/QrBatchDto";

const searchQrsBatchAiImpl = async (id: string): Promise<Either<ErrorEntity, SearchResultEntity<QrBatchEntity>>> => {
    try {
        const relativeUrl: string = `/qrcodes/batches?stablishment_id=${parseInt(id)}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl);
        const parsed = response.qr_batches.map((item: any) => QrBatchDto.fromJSON(item));
        return right({
            data: parsed,
            total: response.length,
            itemsPerPage: response.length,
            page: 1,
            pages: 1,
        });
    } catch (e) {
        return left({ code: "Error deshabilitando QR" });
    }
}

export default searchQrsBatchAiImpl;